<div class="form-date-picker {{config.class}}" [formGroup]="group"  >
    <div for="" class="default-sub-header text-label label-section">
<div class="ngx-timepicker-field">
    <mat-label class="select-label">{{ config.label | translate}}</mat-label>
    <ngx-timepicker-field [format]="24"  [formControlName]="config.name"  [defaultTime]="'00:00'"></ngx-timepicker-field>

</div>
</div>
</div>